<template>
  <div class="space-y-3">
    <div
      v-for="(service, index) in modelValue"
      :key="index"
      class="rounded-md border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/30 p-3">
      <div class="flex items-start gap-3">
        <div class="grid flex-1 grid-cols-1 md:grid-cols-2 gap-3">
          <UiInput
            :model-value="service.name"
            placeholder="Service name"
            @update:model-value="updateService(index, 'name', $event)" />
          <UiInput
            :model-value="service.description"
            placeholder="Optional factual description"
            @update:model-value="updateService(index, 'description', $event)" />
        </div>
        <button
          type="button"
          class="mt-2 text-sm text-red-500 hover:text-red-700"
          :aria-label="`Remove ${service.name || 'service'}`"
          @click="removeService(index)">
          Remove
        </button>
      </div>
    </div>

    <div
      v-if="modelValue.length === 0 && inheritedServices.length"
      class="rounded-md border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 px-3 py-2">
      <p class="text-xs text-blue-800 dark:text-blue-200 mb-2">
        Using the business service list. Add a service below to create a location-specific override.
      </p>
      <div class="flex flex-wrap gap-2">
        <span
          v-for="service in inheritedServices"
          :key="service.name"
          class="rounded bg-white dark:bg-gray-800 px-2 py-1 text-xs text-gray-700 dark:text-gray-200">
          {{ service.name }}
        </span>
      </div>
    </div>

    <button type="button" class="btn btn-secondary btn-sm" @click="addService">
      Add Service
    </button>
  </div>
</template>

<script setup>
import UiInput from '~/javascript/components/ui/form/input/input.vue'

const props = defineProps({
  modelValue: { type: Array, default: () => []},
  inheritedServices: { type: Array, default: () => []}
})

const emit = defineEmits(['update:modelValue'])

function updateService(index, field, value) {
  const services = props.modelValue.map((service) => ({ ...service }))
  services[index][field] = value
  emit('update:modelValue', services)
}

function addService() {
  emit('update:modelValue', [...props.modelValue, { name: '', description: '' }])
}

function removeService(index) {
  emit('update:modelValue', props.modelValue.filter((_, itemIndex) => itemIndex !== index))
}
</script>
